import { useState } from 'react';
import { discussionPosts } from '../data';

export default function DebateLive() {
  const [open, setOpen] = useState<number[]>([]);
  const [liked, setLiked] = useState<Record<number, boolean>>({});

  const toggle = (id: number) =>
    setOpen((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));

  return (
    <section id="debate" className="border-b border-foreground-900/10 bg-background-100/50">
      <div className="mx-auto max-w-6xl px-4 py-8 md:px-6 md:py-12">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="kicker text-xs text-primary-600">热议现场 · DEBATE ROOM</p>
            <h2 className="mt-2 font-heading text-2xl font-semibold tracking-tight text-foreground-950 md:text-3xl">
              评论区现在吵什么
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
              互动与讨论氛围实时抓取，热度越高越靠前。每条都来自真实讨论片段，供你快速了解围观者的真实声量。
            </p>
          </div>
          <span className="hidden items-center gap-2 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800 sm:inline-flex">
            <i className="ri-pulse-line"></i> 实时更新中
          </span>
        </div>

        {/* 热议发帖入口 */}
        <div className="mt-6 flex flex-col gap-3 rounded-lg border border-foreground-900/10 bg-background-50 p-4 sm:flex-row sm:items-center">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-200 font-medium text-secondary-800">
            我
          </div>
          <input
            type="text"
            placeholder="加入这场热议，说两句你的看法…"
            className="min-w-0 flex-1 rounded-md border border-foreground-900/10 bg-background-100 px-4 py-2.5 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400"
          />
          <button className="inline-flex h-10 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-500">
            <i className="ri-send-plane-line"></i>发布讨论
          </button>
        </div>

        {/* 讨论列表 */}
        <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {discussionPosts.map((p) => {
            const isLiked = !!liked[p.id];
            const expanded = open.includes(p.id);
            return (
              <article
                key={p.id}
                className="flex flex-col rounded-lg border border-foreground-900/10 bg-background-50 p-4 transition-shadow hover:border-foreground-900/20"
              >
                <div className="flex items-start gap-3">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-200 font-medium text-secondary-800">
                    {p.avatar}
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                      <span className="text-sm font-medium text-foreground-900">{p.name}</span>
                      <span className="text-xs text-foreground-500">· {p.role}</span>
                      {p.hot && (
                        <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-1.5 py-0.5 text-[11px] font-medium text-primary-800">
                          <i className="ri-fire-fill"></i>热议中
                        </span>
                      )}
                    </div>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-800">{p.text}</p>
                    <div className="mt-2 flex flex-wrap items-center gap-1.5">
                      {p.tags.map((t) => (
                        <span key={t} className="rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-700">
                          #{t}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="mt-3 flex items-center justify-between border-t border-foreground-900/5 pt-2 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-time-line"></i>{p.time}
                  </span>
                  <div className="flex items-center gap-1">
                    <button
                      onClick={() => setLiked((s) => ({ ...s, [p.id]: !s[p.id] }))}
                      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-md px-2 py-1 transition-colors ${
                        isLiked ? 'text-primary-600' : 'text-foreground-500 hover:text-primary-600'
                      }`}
                    >
                      <i className={`${isLiked ? 'ri-heart-fill' : 'ri-heart-3-line'}`}></i>
                      {isLiked ? p.likes : p.likes} 赞
                    </button>
                    <button
                      onClick={() => toggle(p.id)}
                      className="inline-flex items-center gap-1 whitespace-nowrap rounded-md px-2 py-1 text-foreground-500 transition-colors hover:text-primary-600"
                    >
                      <i className="ri-chat-3-line"></i>{p.replies} 回复
                    </button>
                  </div>
                </div>

                {expanded && (
                  <div className="mt-3 rounded-md bg-secondary-100/50 p-3 text-xs leading-relaxed text-foreground-600">
                    <p>展开中的热评回复（演示内容）：这场讨论目前正朝「证据反转让位」方向漂移，站队双方仍在交换截图与录播节点。点击顶部「返回热议」可收起本段。</p>
                  </div>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}